import React, { Fragment } from "react";
import { connect } from "react-redux";
import MerchantStats from "../components/MerchantStats";
import { getMerchantsStats } from "../actions/statsAction";
import Spinner from "../components/layout/Spinner";

class MerchantsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getMerchantsStats("id");
  }

  sort = (param) => {
    this.props.getMerchantsStats(param);
  };

  render() {
    const { loading, merchantStats } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <MerchantStats merchantStats={merchantStats} sort={this.sort} />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ merchantStats }) => ({
  merchantStats: merchantStats,
});
const mapDispatchToProps = (dispatch) => ({
  getMerchantsStats: (merchantStats) =>
    dispatch(getMerchantsStats(merchantStats)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MerchantsContainer);
